import React from 'react'
import styled from 'styled-components'
import get from 'lodash/get'
import {
  Button,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap'
import Top from '../kawari-calendar/team-leave/top'
import "../../static/css/index.css"
import { FONTS, COLORS } from '../../constants'

export default class Searchbar extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (get(nextProps, 'data') !== get(this.props, 'data')
    || get(nextProps, 'moment') !== get(this.props, 'momenr')
    || get(nextProps, 'activeTab') !== get(this.props, 'activeTab')) return true
    return false
  }

  render() {
    const activeTab = get(this.props, 'activeTab')
    const toggle = get(this.props, 'toggle')
    return (
      <Wrapper>
        <NavbarTab tabs>
          <DashboardItem>
            <NavLinkTab
              style={ {
                color: activeTab === '1' ? '#AD2624' : '',
                borderBottom: activeTab === '1' ? '4px solid #AD2624' : '',
                borderTopStyle: 'none',
                borderLeftStyle: 'none',
                borderRightStyle: 'none',
              } }
              onClick={ () => { toggle('1') } }
            >
            Dashboard
            </NavLinkTab>
          </DashboardItem>
          <CalendarItem>
            <NavLinkTab
              style={ { color: activeTab === '2' ? '#AD2624' : '',
                borderBottom: activeTab === '2' ? '4px solid #AD2624' : '',
                borderTopStyle: 'none',
                borderLeftStyle: 'none',
                borderRightStyle: 'none',
              } }
              onClick={ () => { toggle('2') } }
            >
          Calendar
            </NavLinkTab>
          </CalendarItem>
          <HistoryItem>
            <NavLinkTab
              style={ { color: activeTab === '3' ? '#AD2624' : '',
                borderBottom: activeTab === '3' ? '4px solid #AD2624' : '',
                borderTopStyle: 'none',
                borderLeftStyle: 'none',
                borderRightStyle: 'none',
              } }
              onClick={ () => { toggle('3') } }
            >
          Request History
            </NavLinkTab>
          </HistoryItem>
        </NavbarTab>
        <ButtonWrapper>
          { activeTab === '2' &&
            <TeamLeaveTop>
              <Top
                moment={ get(this.props, 'moment') }
                data={ get(this.props, 'data') }
                onMomentChange={ get(this.props, 'onMomentChange') }
                onRangeChange={ get(this.props, 'onRangeChange') }
              />
            </TeamLeaveTop>
          }
          <CustomButton color="danger" onClick={ get(this.props, 'handleLeaveRequest') }>
            Request Leave
          </CustomButton>
          <CustomButton color="danger" onClick={ get(this.props, 'handleCompensateRequest') }>
            Request Compensate
          </CustomButton>
        </ButtonWrapper>
      </Wrapper>
    )
  }
}

const TeamLeaveTop = styled.div`
  flex: 0 0 auto;
  height: 40px;
  display: flex;
  align-items: center;
`
const CalendarItem = styled(NavItem)`
  @media (max-width: 575.98px) {
    display:none;
  }
  @media (max-width: 767.98px) {
    display:none;
  }
`
const DashboardItem = styled(NavItem)`
  @media (max-width: 575.98px) {
    margin: auto;
  }
  @media (max-width: 767.98px) {
    margin: auto;
  }
`
const HistoryItem = styled(NavItem)`
  @media (max-width: 575.98px) {
    margin: auto;
  }
  @media (max-width: 767.98px) {
    margin: auto;
  }
`
const Wrapper = styled.div`
  background-color: #ffffff ;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 767.98px) {
    height: fit-content;
    flex-wrap: wrap;
  }
`
const NavbarTab = styled(Nav)`
  border: none;
  padding-top: 10px;
  font-size: ${FONTS.SMALL_SIZE};
  font-family: ${FONTS.GOTHAM_MEDIUM};
  @media (max-width: 575.98px) {
    margin-right: 1%;
  }
  @media (max-width: 767.98px) {
    margin-right: 1%;
  }
  @media (max-width: 991.98px) {
    margin-right: 1%;
  }
`
const NavLinkTab = styled(NavLink)`
  height: 40px;
  padding-bottom: 20px;
  cursor: pointer;
  &:hover {
    border: none ;
  }
`
const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 10px;
  @media (max-width: 767.98px) {
    width: 100%;
    justify-content: center;
  }
`
const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  height: 30px;
  width: fit-content;
  font-size: ${FONTS.SMALL_SIZE};
  margin-left: 5px;
  margin-right: 5px;
  text-align: center;
  background-color: ${COLORS.SECONDARY_RED};
  padding-top: 0px;
  padding-bottom: 0px;
  @media (max-width: 575.98px) {
    margin: 5px;
    width: fit-content;
    font-size: ${FONTS.SMALL_SIZE};
  }
  @media (max-width: 767.98px) {
    margin: 5px;
    width: fit-content;
    font-size: ${FONTS.SMALL_SIZE};
  }
`



// WEBPACK FOOTER //
// ./src/components/my-leave/search-bar.js